var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3993 0C15.731 0 16 0.335786 16 0.75V7.25C16 9.32107 14.6552 11 12.9963 11H2.05135L5.03051 14.7197C5.24379 14.9859 5.26318 15.4026 5.08868 15.6962L5.03051 15.7803C4.81723 16.0466 4.48349 16.0708 4.24831 15.8529L4.18093 15.7803L0.175954 10.7803C-0.0373236 10.5141 -0.0567126 10.0974 0.117788 9.80379L0.175954 9.71967L4.18093 4.71967C4.41553 4.42678 4.79591 4.42678 5.03051 4.71967C5.24379 4.98594 5.26318 5.4026 5.08868 5.69621L5.03051 5.78033L2.05135 9.5H12.9963C13.9501 9.5 14.7309 8.57484 14.7944 7.40405L14.7985 7.25V0.75C14.7985 0.335786 15.0675 0 15.3993 0Z",
    fill: "#0F314D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterBlue);
export default __webpack_public_path__ + "static/media/enterBlue.f414d272383e75bfa8cb6ede58c1369c.svg";
export { ForwardRef as ReactComponent };